var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "675dc2adc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.410156 0 L 71.660156 0 L 71.660156 65 L 3.410156 65 Z M 3.410156 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "903f2863f6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fcfcfc",
      fillOpacity: 1
    },
    d: "M 46.070312 68.46875 C 45.902344 68.226562 45.566406 68.058594 45.355469 68.089844 L 29.6875 68.179688 C 29.6875 68.179688 29.125 68.332031 28.972656 68.578125 C 28.824219 68.820312 28.792969 69.121094 28.914062 69.382812 C 30.402344 72.796875 33.785156 75 37.507812 75 C 41.285156 75 44.671875 72.75 46.144531 69.273438 C 46.25 69 46.21875 68.699219 46.070312 68.46875 Z M 46.070312 68.46875 "
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#675dc2adc4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fcfcfc",
      fillOpacity: 1
    },
    d: "M 70.980469 60.058594 L 61.371094 52.042969 L 61.371094 30.683594 C 61.371094 19.859375 54.113281 10.703125 44.214844 7.789062 C 44.261719 7.472656 44.324219 7.152344 44.324219 6.820312 C 44.324219 3.054688 41.273438 0 37.507812 0 C 33.742188 0 30.691406 3.054688 30.691406 6.820312 C 30.691406 7.152344 30.75 7.472656 30.796875 7.789062 C 20.898438 10.703125 13.640625 19.84375 13.640625 30.683594 L 13.640625 52.042969 L 4.015625 60.058594 C 3.621094 60.378906 3.410156 60.863281 3.410156 61.363281 L 3.410156 63.066406 C 3.410156 64.007812 4.167969 64.765625 5.109375 64.765625 L 69.886719 64.765625 C 70.828125 64.765625 71.589844 64.007812 71.589844 63.066406 L 71.589844 61.363281 C 71.589844 60.863281 71.359375 60.378906 70.980469 60.058594 Z M 34.121094 7.089844 C 34.121094 7 34.089844 6.910156 34.089844 6.820312 C 34.089844 4.9375 35.625 3.402344 37.507812 3.402344 C 39.390625 3.402344 40.90625 4.9375 40.90625 6.820312 C 40.90625 6.910156 40.890625 7 40.875 7.089844 C 39.769531 6.941406 38.644531 6.820312 37.492188 6.820312 C 36.335938 6.820312 35.230469 6.925781 34.121094 7.089844 Z M 34.121094 7.089844 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWhite);
export default __webpack_public_path__ + "static/media/bell-white.8cfb362270a3a2ab0460073ccda4d16d.svg";
export { ForwardRef as ReactComponent };